<template>
  <article :hidden="hidden" :class="{ single: availablesCount === 1 }">
    <ButtonCategory
      v-for="(child, index) in categories"
      :key="child.id"
      v-model:available="availables[index]"
      class="button-additional"
      :category="child"
    />
  </article>
</template>
<script lang="ts" setup>
import type { CategorySchema } from '~/types/schema';
interface Props {
  title?: string | null;
  categories: CategorySchema[];
  parentDisplayType:
    | 'default'
    | 'center_circle'
    | 'dimensionTest_and_result'
    | 'sponsor'
    | 'shortcuts'
    | 'additional';
}

const props = defineProps({
  title: { default: null },
  categories: null,
  parentDisplayType: null
});

const availables = ref<boolean[]>(Array(props.categories.length).fill(true));

const availablesCount = computed(() => {
  return availables.value.reduce((acc, curr) => {
    if (curr) acc += 1;
    return acc;
  }, 0);
});

watch(
  () => props.categories.length,
  (length) => Array(props.categories.length).fill(true)
);

const hidden = computed(() => {
  const hidden = !availables.value.find((b) => b);
  return hidden;
});
</script>
<style lang="scss" scoped>
article {
  &.hidden {
    display: none;
  }

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(13.2rem, 1fr));
  width: 100%;
  gap: var(--gap_n);
  &.single {
    grid-template-columns: 1fr;
    .button-additional {
      aspect-ratio: unset;
      padding: var(--gap_n);
    }
  }
}
</style>
